'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../external/classnames/index.js');

var FooterContact = require('./FooterContact/FooterContact.js');

var FooterLinks = require('./FooterLinks/FooterLinks.js');

var FooterLegal = require('./FooterLegal/FooterLegal.js');

var FooterCopyright = require('./FooterCopyright/FooterCopyright.js');

var FooterSponsor = require('./FooterSponsor/FooterSponsor.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Footer = function Footer(props) {
  var className = props.className;
  var AtTheLabs = [{
    label: 'Business Opportunities',
    link: 'https://www.lanl.gov/business/procurement-opportunities.php'
  }, {
    label: 'Jobs',
    link: 'https://lanl.jobs'
  }, {
    label: 'Organizations',
    link: 'https://www.lanl.gov/org/index.php'
  }, {
    label: 'Research Library',
    link: 'https://www.lanl.gov/library/'
  }, {
    label: 'User Facilities',
    link: 'https://www.lanl.gov/science-innovation/science-programs/office-of-science-programs/programs-user-facilities.php'
  }];
  var Information = [{
    label: 'Emergency, Fire',
    link: 'https://www.lanl.gov/resources/emergency/index.php'
  }, {
    label: 'Events, Lectures',
    link: 'https://www.lanl.gov/calendar//index.php'
  }, {
    label: 'Ombuds',
    link: 'https://www.lanl.gov/resources/ombuds/index.php'
  }, {
    label: 'Resources',
    link: 'https://www.lanl.gov/resources/index.php'
  }, {
    label: 'Reading Room',
    link: 'https://www.lanl.gov/environment/public-reading-room.php'
  }, {
    label: 'Science Museum',
    link: 'https://www.lanl.gov/museum//index.php'
  }];
  var ForEmployees = [{
    label: 'AskIT ',
    link: 'https://askit-sso.lanl.gov/rsso/start'
  }, {
    label: 'LANLInside ',
    link: 'https://int.lanl.gov/'
  }, {
    label: 'MyMail ',
    link: 'https://int.lanl.gov/'
  }, {
    label: 'New Hire Process ',
    link: 'https://www.lanl.gov/careers/employees-retirees/new-hires/index.php'
  }, {
    label: 'SSL Portal',
    link: 'https://portal.lanl.gov/'
  }, {
    label: 'Training',
    link: 'https://extrain.lanl.gov/'
  }];
  var classes = index['default']('lanl-footer', className);
  return /*#__PURE__*/React__default['default'].createElement("footer", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes
  }, /*#__PURE__*/React__default['default'].createElement(FooterContact.FooterContact, null), /*#__PURE__*/React__default['default'].createElement(FooterLinks.FooterLinks, {
    header: 'At The Lab',
    data: AtTheLabs
  }), /*#__PURE__*/React__default['default'].createElement(FooterLinks.FooterLinks, {
    header: 'Information',
    data: Information
  }), /*#__PURE__*/React__default['default'].createElement(FooterLinks.FooterLinks, {
    header: 'For Employees',
    data: ForEmployees
  }), /*#__PURE__*/React__default['default'].createElement(FooterSponsor.FooterSponsor, {
    header: 'DOE'
  }), /*#__PURE__*/React__default['default'].createElement(FooterLegal.FooterLegal, null), /*#__PURE__*/React__default['default'].createElement(FooterCopyright.FooterCopyright, null)));
};

Footer.propTypes = {
  className: PropTypes__default['default'].string
};
exports.Footer = Footer;
exports['default'] = Footer;